/**
 * Continue Conversation Prompt Component
 * Shows when a stored conversation is detected
 */

'use client';

import { Clock, RotateCcw } from 'lucide-react';
import { formatConversationAge } from './conversationStorage';

export function ContinueConversationPrompt({
  conversationAge,
  onContinue,
  onStartNew,
}: {
  conversationAge: number;
  onContinue: () => void;
  onStartNew: () => void;
}) {
  return (
    <div className="absolute inset-0 z-10 bg-background/95 backdrop-blur-sm flex items-center justify-center p-6">
      <div className="bg-card rounded-2xl shadow-2xl p-6 max-w-sm w-full border border-border/50 animate-message-slide-up">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
            <Clock size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground text-base">
              Welcome back!
            </h3>
            <p className="text-xs text-muted-foreground">
              {formatConversationAge(conversationAge)}
            </p>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mb-6 leading-relaxed">
          Would you like to continue where you left off, or start a fresh conversation?
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={onContinue}
            className="w-full px-4 py-3 bg-foreground text-background rounded-xl font-semibold text-sm hover:opacity-90 transition-all active:scale-[0.98] flex items-center justify-center gap-2"
          >
            Continue conversation
          </button>
          <button
            onClick={onStartNew}
            className="w-full px-4 py-3 bg-muted text-foreground rounded-xl font-semibold text-sm hover:opacity-90 transition-all active:scale-[0.98] flex items-center justify-center gap-2"
          >
            <RotateCcw size={16} />
            Start fresh
          </button>
        </div>
      </div>
    </div>
  );
}
